export const googleApi = {
  mapKey: process.env.GOOGLE_API_KEY,
  geoKey: process.env.GOOGLE_GEOCODE_KEY
};

export const mapConfigs = {
  // Boundaries for autocomplete to only autocomplete locations within Simmons Service Area
  AutoCompleteBoundaries: {
    north: 39.489706,
    south: 27.298776,
    east: -83.524812,
    west: -98.880541
  },
  // Region codes for autocomplete suggestions
  includedRegionCodes: ['us']
};

export const defaultOpt = {
  // Default search radius
  radius: 50,
  // Default map center: Simmons corp headquarters
  pos: { lat: 34.224637, lng: -92.002931 },
  // Starting zoom level
  zoom: 10
};

